import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { refreshTier } from './services/api';
import Landing from './pages/Landing';
import ComingSoon from './pages/ComingSoon';
import RecruiterLanding from './pages/RecruiterLanding';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import MatchedJobs from './pages/MatchedJobs';
import MyApplications from './pages/MyApplications';
import AutoApplySettings from './pages/AutoApplySettings';
import Documents from './pages/Documents';
import RecruiterLogin from './pages/RecruiterLogin';
import RecruiterRegister from './pages/RecruiterRegister';
import RecruiterDashboard from './pages/RecruiterDashboard';
import RecruiterProfile from './pages/RecruiterProfile';
import RecruiterCompanyView from './pages/RecruiterCompanyView';
import PostJob from './pages/PostJob';
import EditJob from './pages/EditJob';
import JobApplications from './pages/JobApplications';
import JobSeekerProfileSetup from './pages/JobSeekerProfileSetup';
import RecruiterProfileSetup from './pages/RecruiterProfileSetup';
import JobSeekerProfile from './pages/JobSeekerProfile';
import CompanyProfile from './pages/CompanyProfile';
import VerifyEmail from './pages/VerifyEmail';
import SeekerMessages from './pages/SeekerMessages';
import RecruiterMessages from './pages/RecruiterMessages';
import SalaryInsights from './pages/SalaryInsights';
import InterviewPrep from './pages/InterviewPrep';
import CVOptimise from './pages/CVOptimise';
import NotificationSettings from './pages/NotificationSettings';
import EmailTemplates from './pages/EmailTemplates';
import RecruiterAnalytics from './pages/RecruiterAnalytics';
import SeekerProfileView from './pages/SeekerProfileView';
import Pricing from './pages/Pricing';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import SearchCompanies from './pages/SearchCompanies';
import SearchSeekers from './pages/SearchSeekers';
import './App.css';

function App() {
  useEffect(() => {
    // Sync the user's current plan from the backend on every app load
    refreshTier();
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/recruiters" element={<RecruiterLanding />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:jobId" element={<JobDetail />} />
            <Route path="/matched-jobs" element={<MatchedJobs />} />
            <Route path="/my-applications" element={<MyApplications />} />
            <Route path="/auto-apply-settings" element={<AutoApplySettings />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/profile" element={<JobSeekerProfile />} />
            <Route path="/profile-setup" element={<JobSeekerProfileSetup />} />
            <Route path="/company/:companyName" element={<CompanyProfile />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            
            <Route path="/messages" element={<SeekerMessages />} />
            <Route path="/salary-insights" element={<SalaryInsights />} />
            <Route path="/interview-prep" element={<InterviewPrep />} />
            <Route path="/cv-optimise" element={<CVOptimise />} />
            <Route path="/notification-settings" element={<NotificationSettings />} />
            <Route path="/recruiter/email-templates" element={<EmailTemplates />} />

            {/* Recruiter Routes */}
            <Route path="/recruiter/login" element={<RecruiterLogin />} />
            <Route path="/recruiter/register" element={<RecruiterRegister />} />
            <Route path="/recruiter/profile-setup" element={<RecruiterProfileSetup />} />
            <Route path="/recruiter/company" element={<RecruiterCompanyView />} />
            <Route path="/recruiter/profile" element={<RecruiterProfile />} />
            <Route path="/recruiter/dashboard" element={<RecruiterDashboard />} />
            <Route path="/recruiter/post-job" element={<PostJob />} />
            <Route path="/recruiter/edit-job/:jobId" element={<EditJob />} />
            <Route path="/recruiter/jobs/:jobId/applications" element={<JobApplications />} />
            <Route path="/recruiter/messages" element={<RecruiterMessages />} />
            <Route path="/recruiter/analytics" element={<RecruiterAnalytics />} />
            <Route path="/recruiter/seeker-profile/:userId" element={<SeekerProfileView />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/search-companies" element={<SearchCompanies />} />
            <Route path="/recruiter/search-seekers" element={<SearchSeekers />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
